import React from 'react';
import { ImageIcon, Phone, MapPin, Sparkles, Send } from 'lucide-react';

export default function HlushmanHouseCard() {
    const instagramUrl = "https://www.instagram.com/hlushman_house/";
    const phone = "+380 (97) 902 00 18";

    const services = [
        { title: "Затишні локації", desc: "Аренда відпочинкових будинків у мальовничих куточках" },
        { title: "Комфорт та затишок", desc: "Сучасний дизайн, усе необхідне для вашого ідеального вікенду" },
        { title: "Індивідуальний підхід", desc: "Допомога у організації вашого відпочинку або подій" },
    ];

    return (
        <div className="min-h-screen bg-neutral-900 text-neutral-100 font-sans flex flex-col items-center justify-center p-4 sm:p-6">
            <div className="max-w-md w-full bg-neutral-800/80 backdrop-blur-md rounded-3xl border border-neutral-700 shadow-2xl overflow-hidden p-6 space-y-8">

                {/* Шапка / Профіль */}
                <div className="flex flex-col items-center text-center space-y-4">
                    <div className="relative">
                        <div className="w-24 h-24 rounded-full bg-gradient-to-tr from-amber-500 via-rose-500 to-purple-600 p-1 shadow-lg">
                            <div className="w-full h-full bg-neutral-900 rounded-full flex items-center justify-center border-2 border-neutral-900 overflow-hidden">
                <span className="text-2xl font-bold bg-gradient-to-r from-amber-200 to-amber-500 bg-clip-text text-transparent">
                  <img src="/logo.jpg" alt="logo"/>
                </span>
                            </div>
                        </div>
                        <Sparkles className="absolute -top-1 -right-1 w-6 h-6 text-amber-400 animate-pulse" />
                    </div>

                    <div>
                        <h1 className="text-2xl font-extrabold tracking-tight text-white">Hlushman House</h1>
                        <p className="text-sm text-neutral-400 mt-1 flex items-center justify-center gap-1">
                            <MapPin className="w-4 h-4 text-rose-500" /> Відпочинок & Затишок
                        </p>
                    </div>

                    <p className="text-sm text-neutral-300 leading-relaxed max-w-xs">
                        Твоя ідеальна локація для перезавантаження, затишного відпочинку та незабутніх моментів.
                    </p>
                </div>

                {/* Основні кнопки дій (CTA) */}
                <div className="space-y-3">
                    <a
                        href={instagramUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center gap-3 w-full py-3.5 px-4 bg-gradient-to-r from-purple-600 via-rose-500 to-amber-500 hover:opacity-95 text-white font-semibold rounded-2xl transition duration-300 shadow-lg shadow-rose-950/30"
                    >
                        <ImageIcon className="w-5 h-5" />
                        Відкрити Instagram
                    </a>

                    <a
                        href={`https://t.me/hlushman_house`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center gap-3 w-full py-3.5 px-4 bg-neutral-700 hover:bg-neutral-600 text-white font-medium rounded-2xl transition duration-200"
                    >
                        <Send className="w-5 h-5 text-sky-400" />
                        Написати в Telegram
                    </a>

                    <a
                        href={`tel:${phone}`}
                        className="flex items-center justify-center gap-3 w-full py-3.5 px-4 bg-neutral-700/60 hover:bg-neutral-700 text-neutral-200 font-medium rounded-2xl transition duration-200 border border-neutral-600/50"
                    >
                        <Phone className="w-5 h-5 text-emerald-400" />
                        Зателефонувати
                    </a>
                </div>

                {/* Блок послуг / переваг */}
                <div className="space-y-3 pt-2">
                    <h2 className="text-xs font-semibold uppercase tracking-wider text-neutral-400 text-center">
                        Що ми пропонуємо
                    </h2>
                    <div className="grid gap-2.5">
                        {services.map((item, index) => (
                            <div
                                key={index}
                                className="p-3.5 bg-neutral-900/60 rounded-xl border border-neutral-700/50 hover:border-neutral-600 transition duration-200"
                            >
                                <h3 className="text-sm font-semibold text-amber-300">{item.title}</h3>
                                <p className="text-xs text-neutral-400 mt-0.5">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Футер */}
                <div className="text-center pt-2">
                    <p className="text-xs text-neutral-500">
                        © {new Date().getFullYear()} Hlushman House. Всі права захищено.
                    </p>
                </div>

            </div>
        </div>
    );
}